import Button from "components/Button"
import Checkbox from "components/Checkbox"
import ErrorMessage from "components/ErrorMessage"
import Input from "components/Input"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { LoginWrapper } from "./styled"
import { useFormik } from "formik"
import * as Yup from "yup"
import { authError } from "errors/auth"
import { REGEX_PASSWORD } from "constants/regex"
import { encryptInfo, decryptInfo } from "helpers/remember_login"
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { authAction } from "redux/slice/authSlice"
import { authSelector } from 'redux/selector'
import Loading from "components/Loading"

const Login = () => {
    const [remember, setRemember] = useState(false);
    const [errorMessage, setErrorMessage] = useState("")


    const authState = useSelector(authSelector)
    const dispatch = useDispatch()
    const formData = useFormik({
        initialValues: {
            value: "",
            password: "",
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            value: Yup.string().trim().required(authError.requiredAccount),
            password: Yup.string().trim().required(authError.requiredPassword).matches(REGEX_PASSWORD, authError.invalidPassword),
        }),
        onSubmit: (values, { setFieldError }) => {
            if (remember) {
                encryptInfo(values.value, values.password);
            } else {
                localStorage.removeItem("remember_login");
            }
            if (!authState.isFetching)
                dispatch(authAction.login({ values, setFieldError, setErrorMessage }))
        }
    })
    useEffect(() => {
        const getInfoRemember =
            JSON.parse(localStorage.getItem("remember_login") || "{}") ?? "";
        if (Object.values(getInfoRemember).length > 0) {
            const data = decryptInfo(getInfoRemember.value, getInfoRemember.password);
            formData.setValues(data);
            setRemember(true);
        }
    }, []);

    return (
        <LoginWrapper className="flex-center  pt-35">
            {
                authState.isFetching && <Loading />
            }
            <form onSubmit={formData.handleSubmit}>
                <h1 className="text-black s-24 bold text-center mb-50">ĐĂNG NHẬP</h1>
                {
                    errorMessage !== "" &&
                    <div className="mb-25">
                        <ErrorMessage>{errorMessage}</ErrorMessage>
                    </div>
                }
                <div className="form-input mb-25">
                    <Input
                        placeholder="Tên tài khoản, email, số điện thoại"
                        name="value"
                        value={formData.values.value}
                        onChange={formData.handleChange}
                        isError={!!formData.errors.value}
                        message={formData.errors.value}
                    />
                </div>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Mật khẩu"
                        type="password"
                        name="password"
                        value={formData.values.password}
                        onChange={formData.handleChange}
                        isError={!!formData.errors.password}
                        message={formData.errors.password}
                    />
                </div>
                {/* <div className="form-input mb-50">
                    <div className="flex-center">
                        <Checkbox className="checkbox" id="remember" checked={remember} onChange={() => setRemember(!remember)} />
                        <label className="ml-5 clickable" htmlFor="remember">Nhớ đăng nhập</label>
                    </div>
                </div> */}
                <Button className="action-danger-1 btn-login" type="submit" isNa={authState.isFetching}>Đăng nhập</Button>
                <div className="mt-25 flex-space">
                    <Link to="/forgot-password" className="text-link s-16 text-link-hover ">Quên mật khẩu?</Link>
                    <Link to="/register" className="text-link s-16 text-link-hover ">Chưa có tài khoản, đăng ký</Link>
                </div>
            </form>
        </LoginWrapper>
    )
}

export default Login